import { MapPin, Sparkles, Navigation } from "lucide-react";
import { Reveal } from "./Reveal";

const PLACES = [
  {
    icon: MapPin,
    name: "Valencia",
    desc: "C/ del Dr. Romagosa 10, Ciutat Vella, 46002 València. Nuestro primer local abre en septiembre: síguenos para ser de los primeros en entrar.",
    status: "Próxima apertura · Septiembre",
    href: "https://maps.app.goo.gl/3ZcPNSGucypFjynt5",
    active: true,
    id: "valencia",
  },
  {
    icon: Sparkles,
    name: "Próximamente",
    desc: "La manada CROC crece. Estamos preparando las siguientes ubicaciones.",
    status: "Próximamente",
    active: false,
    id: "proximamente-1",
  },
  {
    icon: Navigation,
    name: "¿Tu ciudad?",
    desc: "¿Quieres un CROC LAB cerca de ti? Escríbenos desde la sección de contacto y cuéntanoslo.",
    status: "Próximamente",
    active: false,
    id: "proximamente-2",
  },
];

const Locales = () => (
  <section id="locales" data-testid="locales-section" className="py-16 md:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-pink">Locales</p>
        <h2 className="mt-3 font-display font-bold tracking-tight text-brand-charcoal text-3xl md:text-4xl">
          Empezamos en Valencia
        </h2>
        <p className="mt-4 text-base md:text-lg text-brand-charcoal/75 leading-relaxed">
          CROC LAB nace en Valencia, pero no viene a quedarse quieto. Este es el
          primer paso de una marca que quiere estar en muchos más sitios.
        </p>
      </Reveal>
      <div className="mt-12 grid md:grid-cols-3 gap-6">
        {PLACES.map((place, i) => (
          <Reveal key={place.id} delay={i * 0.08} className="h-full">
            <article
              data-testid={`locales-card-${place.id}`}
              className={
                place.active
                  ? "h-full rounded-3xl p-8 bg-brand-cream border-2 border-brand-pink shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
                  : "h-full rounded-3xl p-8 border-2 border-dashed border-brand-charcoal/20 opacity-70"
              }
            >
              <div
                className={
                  place.active
                    ? "w-14 h-14 rounded-full bg-brand-pink text-white flex items-center justify-center"
                    : "w-14 h-14 rounded-full bg-brand-charcoal/5 text-brand-charcoal/50 flex items-center justify-center"
                }
              >
                <place.icon className="w-7 h-7" aria-hidden="true" />
              </div>
              <h3 className="mt-6 font-display font-semibold text-xl md:text-2xl text-brand-charcoal">
                {place.name}
              </h3>
              <p className="mt-3 text-sm md:text-base text-brand-charcoal/70 leading-relaxed">
                {place.desc}
              </p>
              <span
                data-testid={`locales-status-${place.id}`}
                className={
                  place.active
                    ? "mt-6 inline-block text-xs font-semibold uppercase tracking-wide text-white bg-brand-pink rounded-full px-3 py-1.5"
                    : "mt-6 inline-block text-xs font-semibold uppercase tracking-wide text-brand-charcoal/45 bg-brand-charcoal/5 rounded-full px-3 py-1.5"
                }
              >
                {place.status}
              </span>
              {place.href && (
                <a
                  data-testid={`locales-directions-${place.id}`}
                  href={place.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand-charcoal hover:text-brand-pink transition-colors"
                >
                  <Navigation className="w-4 h-4 text-brand-pink" aria-hidden="true" />
                  Cómo llegar · Google Maps
                </a>
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Locales;
